import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { PageHero } from '../../../components/pageHero/PageHero';
import { endpoints } from 'endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import { CreateRecordsPopup, SelectedRecord } from '../../../pages/wondeIntegration/wIPopups/CreateRecordsPopup';
import { PreviouslyMatchedRecords } from '../wIFeatures/PreviouslyMatchedRecords';
import { SyncDataOption } from '../WondeIntegration';

type WIStep3Props = {
  setCurrentStep: Dispatch<SetStateAction<number>>;
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  currentSynOpt: SyncDataOption;
};

export const EMAIL_ERROR_MSG = `One or more of the records you have selected to create either already exists in Get Set or has no associated email address in your MIS and cannot be created.`;
const DEFAULT_STRING = 'Here are the records that exist in Wonde but not in Get Set. Please select the records you wish to create in Get Set.';

export const WIStep3: React.FC<WIStep3Props> = ({ 
  setCurrentStep, 
  setWondeIntegration,
  currentSynOpt, 
}) => {
  const [checkTableLoading, setCheckTableLoading] = useState<any>(false);
  const [listUrl, setListUrl] = useState<string>("");
  const [submitUrl, setSubmitUrl] = useState<string>("");  
  const [pageName, setPageName] = useState<string | null>(null);
  const [recordsSelected, setRecordsSelected] = useState<any>([]);
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);
  const [createRecordsPopupOpen, setCreateRecordsPopupOpen] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);

  const [createErrors, setCreateErrors] = useState<number[] | null>(null);

  useEffect(() => {
    document.body.style.overflowY = '';
  }, []);   

  useEffect(() => {
    if(currentSynOpt){
      loadData();
    }
  }, [currentSynOpt]);

  const loadData = async () => {
    setPageName(`Sync ${currentSynOpt} Records`);

    const currentListUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep3List :
      endpoints.wondeIntegration.pupilStep3List;

    setListUrl(currentListUrl);

    const currentSubmitUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep3UnmatchedWondeClasses :
      endpoints.wondeIntegration.pupilStep3UnmatchedWondeClasses;

    setSubmitUrl(currentSubmitUrl);
  };

  return (
    <div className="PageContent WondeIntegrationPage Step3">
      <PageHero title={pageName ?? ''} />
      <div className="WidthContent">
        <div className="TopInfoRow">
          <div className="LeftSide">
            <h2>Wonde Records</h2>
          </div>
          <div className="RightSide">
            <p>Step 3 of 4</p>
          </div>
        </div>
        <h4>Select records to be created in get set 4 education</h4>

        <p className='OnlyCreateText'>{DEFAULT_STRING}</p>

        {(createErrors ?? [])?.length > 0 && (
          <>
            <p className="GeneralError2 NoMarginBottom">{EMAIL_ERROR_MSG}</p>
          </>
        )}

        {listUrl &&
          <InfoTable
            listUrl={listUrl}
            firstColWidth={215}
            firstColWidthSm={110}
            updateListStatus={true}
            setIsPanelClosed={setIsPanelClosed}
            isPanelClosed={isPanelClosed}
            allowSelectAll={true}
            filterTable={false}
            setCheckTableLoading={setCheckTableLoading}
            hideSideMenu={true}
            getSelectedOpts={{ 
              "getOpts": setRecordsSelected, 
              "id": currentSynOpt === "Class" ? 
                "wondeclasses__id" :
                currentSynOpt === "Pupil" ?
                "wondepupils__id" :
                "wondeschoolusers__id"
            }}
            rowHighlight={true}
            hideBtmCtrls={true}
            setTableData={setTableData}
            rowClassname={(data: SelectedRecord) => createErrors?.includes(data.wondeschoolusers__id) ? 'ErrorRow' : ''}
          >
          </InfoTable>
        }

        {(createErrors ?? [])?.length > 0 && (
          <>
            <p className="GeneralError2 NoMarginBottom">{EMAIL_ERROR_MSG}</p>
          </>
        )}

        <PreviouslyMatchedRecords currentSynOpt={currentSynOpt} />

        <div className="BtmBtns">
          <div className="Btn BtnWhite LeftBtn" onClick={() => {
            window.scrollTo(0, 0);
            setWondeIntegration(false);
          }}>Cancel</div>
          {!checkTableLoading &&
            <div className="Btn BtnOrange RightBtn" onClick={() => {
              setCreateRecordsPopupOpen(true);
              setCreateErrors(null);
            }}>Confirm</div>
          }
        </div>
      </div>

      {createRecordsPopupOpen && (
        <CreateRecordsPopup
          panelOpen={createRecordsPopupOpen}
          togglePanelOpen={setCreateRecordsPopupOpen}
          recordsSelected={recordsSelected}
          setCurrentStep={setCurrentStep}
          currentSubmitUrl={submitUrl}
          currentSynOpt={currentSynOpt}
          tableData={tableData}
          setCreateErrors={setCreateErrors}
        />        
      )}       
    </div>
  );
};